import { Card, CardContent, CardHeader } from "@/components/ui/card.tsx";

interface ContentCardProps {
    title: string
    headline: string | null
    content: string | null
    source?: string | null
    fallbackHeadline?: string
    fallbackContent?: string
}

export default function ContentCard({
                                        title,
                                        headline,
                                        content,
                                        source,
                                        fallbackHeadline,
                                        fallbackContent
                                    }: ContentCardProps) {
    return (
        <Card>
            <CardHeader>
                <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">{title}</h3>
            </CardHeader>
            <CardContent>
                <h4 className="font-medium text-slate-900 dark:text-white">
                    {headline || fallbackHeadline || title}
                </h4>
                <p className="text-slate-700 dark:text-slate-300">
                    {content || fallbackContent || `No ${title.toLowerCase()} details available`}
                </p>
                <div className="pt-2">
                    <div className="text-xs text-slate-500 dark:text-slate-400 mb-2">Sources</div>
                    <a target="_blank" href={source || 'company.com'}

                       className="inline-flex items-center text-primary hover:text-primary/80 underline underline-offset-4 transition-colors">{source || 'company.com'}</a>
                </div>
            </CardContent>

        </Card>
    )
}